import { render, staticRenderFns } from "./hong_bao_yu.vue?vue&type=template&id=968ec56a&scoped=true"
import script from "./hong_bao_yu.vue?vue&type=script&lang=ts"
export * from "./hong_bao_yu.vue?vue&type=script&lang=ts"
import style0 from "./hong_bao_yu.vue?vue&type=style&index=0&id=968ec56a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968ec56a",
  null
  
)

export default component.exports